"use client";

import { motion } from "framer-motion";
import { FaAngleRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import HeroAgentCard from "./HeroAgentCard";

export default function HeroSection({ featuredAgent, agentLoading }) {
  const navigate = useNavigate();

  return (
    <section className="container">
      <div className="flex flex-col md:flex-row items-center gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex-1 max-w-2xl"
        >
          <h1 className="text-3xl text-center xl:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-[42px] sm:leading-[52px] lg:leading-[64px] xl:leading-[72px]">
            A better{" "}
            <span className="relative inline-block text-[#097FE6]">
              platform
              <svg
                className="absolute h-2 xl:3 left-4 w-[calc(100%-25px)] xl:w-[calc(100%-20px)] -bottom-1 lg:bottom-0 xl:bottom-1"
                viewBox="0 0 100 12"
                preserveAspectRatio="none"
              >
                <path
                  d="M2 10 Q50 0 98 10"
                  fill="none"
                  stroke="#3b82f6"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </span>{" "}
            for Agents & Buyers in Nigeria
          </h1>

          <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-500 max-w-xl">
            We are building the next generation of real estate technology for
            Nigeria designed to make finding, renting, and buying property
            simpler, faster, and safer.
          </p>

          <motion.button
            whileHover="hover"
            initial="rest"
            animate="rest"
            className="my-8 sm:my-10 w-full xl:w-auto justify-center xl:justify-start inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#097FE6] text-white text-sm font-medium shadow-md"
            style={{ marginTop: 20 }}
            onClick={() => navigate("/sign-up")}
          >
            <span className="text-white">Start Now</span>
            <motion.span
              variants={{
                rest: { x: 0, opacity: 0.8 },
                hover: { x: 4, opacity: 1 },
              }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              <FaAngleRight className="w-4 h-4 text-white" />
            </motion.span>
          </motion.button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
          className="flex-1 flex justify-center md:justify-end w-full mb-8 lg:mb-0"
        >
          <div className="relative w-full max-w-[440px] min-h-[400px] sm:min-h-[460px] md:min-h-[520px] lg:min-h-[560px] xl:min-h-[600px] flex items-center justify-center py-4">
            <svg viewBox="0 0 300 300" className="absolute w-full h-full">
              <circle
                cx="150"
                cy="150"
                r="130"
                fill="none"
                stroke="#000"
                strokeOpacity="0.4"
                strokeWidth="1.5"
                strokeDasharray="2 10"
              />
            </svg>

            <motion.svg
              viewBox="0 0 300 300"
              className="absolute w-full h-full"
              animate={{ rotate: 360 }}
              transition={{
                duration: 28,
                repeat: Infinity,
                ease: "linear",
              }}
            >
              <circle cx="150" cy="20" r="6" fill="#facc15" />
              <circle cx="280" cy="150" r="6" fill="#22c55e" />
              <circle cx="150" cy="280" r="6" fill="#3b82f6" />
              <circle cx="20" cy="150" r="6" fill="#d1d5db" />
            </motion.svg>

            <div className="relative z-10 ">
              {featuredAgent || agentLoading ? (
                <HeroAgentCard agent={featuredAgent} loading={agentLoading} />
              ) : (
                <div className="w-[280px] sm:w-[300px] rounded-2xl bg-white border border-[#EAEAEA] p-8 text-center shadow-sm">
                  <p className="text-[#000929] font-medium mb-2">
                    Meet our agents
                  </p>
                  <p className="text-sm text-gray-500 mb-6">
                    Connect with verified agents across Nigeria.
                  </p>
                  <Link
                    to="/find-agents"
                    className="inline-flex rounded-full bg-[#097FE6] text-white px-6 py-3 text-sm font-medium hover:opacity-95"
                  >
                    Find agents
                  </Link>
                </div>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
